// Early access (temporary): the screen an account sees until it enters the access key it was given.
import { useState, type FormEvent } from 'react';
import { unlockAccess } from '../access';

export function EarlyAccess({ onUnlocked }: { onUnlocked: () => void }) {
  const [key, setKey] = useState('');
  const [busy, setBusy] = useState(false);
  const [refusal, setRefusal] = useState('');
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!key.trim() || busy) return;
    setBusy(true);
    setRefusal('');
    const result = await unlockAccess(key.trim());
    setBusy(false);
    if (result.ok) onUnlocked();
    else setRefusal(result.reason);
  };
  return (
    <main className="min-h-screen bg-stone-950 text-stone-100 flex items-center justify-center p-6">
      <section className="max-w-md w-full rounded-lg border border-stone-800 bg-stone-900 p-6 space-y-4" data-testid="early-access">
        <h1 className="text-2xl font-semibold">Early access</h1>
        <p className="text-stone-300">The tabletop is in early testing. Enter the access key you were given to unlock it for your account.</p>
        <form className="space-y-3" onSubmit={submit}>
          <label className="block space-y-1 text-sm">
            <span className="text-stone-400">Access key</span>
            <input
              data-testid="access-key" type="text" autoComplete="off" spellCheck={false} value={key} onChange={(e) => setKey(e.target.value)}
              className="w-full rounded border border-stone-700 bg-stone-950 px-3 py-2 text-stone-100 focus:border-amber-500 focus:outline-none"
            />
          </label>
          {refusal && <p role="alert" data-testid="access-refusal" className="text-sm text-amber-300">{refusal}</p>}
          <button type="submit" disabled={busy || !key.trim()} className="vtt-btn-primary rounded bg-amber-600 px-3 py-1 font-medium text-stone-950 disabled:opacity-50">
            Unlock
          </button>
        </form>
      </section>
    </main>
  );
}
